import api from '../utils/api';

export const getReportList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/report/getReport`,
        method: "POST",
        data: data,
        ...options,
    });
}